import axios from "./axios";

const getMemberDetails = (id) =>
  axios.get(`/users/${id}/`).then(
    (res) => res,
    (err) => err.response
  );

export { getMemberDetails };
